/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pilot_How_ContinueInputs */



/**
* | output |
* | --- |
* | "Next" |
*
* @param {Onboarding_Pilot_How_ContinueInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_how_continue = /** @type {((inputs?: Onboarding_Pilot_How_ContinueInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_How_ContinueInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Volgende")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Suivant")
	return /** @type {LocalizedString} */ ("Next")
});